import { render, staticRenderFns } from "./DateFormatter.vue?vue&type=template&id=910f1854&"
import script from "./DateFormatter.vue?vue&type=script&lang=js&"
export * from "./DateFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('910f1854')) {
      api.createRecord('910f1854', component.options)
    } else {
      api.reload('910f1854', component.options)
    }
    module.hot.accept("./DateFormatter.vue?vue&type=template&id=910f1854&", function () {
      api.rerender('910f1854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Ss7mg8owysBL/JS/DateFormatter.vue"
export default component.exports